// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e60b9ba9","517":"08d33b1d","716":"1bd18e80","835":"a641f95f"}[chunkId] + ".chunk.js";
};